import { useGameStore } from '@/react/state/gameStore'
import { appBus } from '@/app/app-events'
import { logger } from '@/app/logger'
import type { BnBNode } from './bnb-manager'

export class BnBUI {
  constructor() {
    appBus.on('bnb-started', ({ rootNodeId }) => {
      logger.log('[BnBUI Adapter] bnb-started')
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_STARTED' })
      useGameStore.getState().updateBnBState({
        rootNodeId,
        currentNodeId: rootNodeId,
        nodes: new Map(),
        incumbentNodeId: null,
      })
    })

    appBus.on('bnb-node-activated', ({ nodeId, node }) => {
      logger.log('[BnBUI Adapter] bnb-node-activated', nodeId)
      const state = useGameStore.getState().ui.bnbState
      const newNodes = new Map(state.nodes)

      if (node) {
        newNodes.set(node.id, node as BnBNode)
      }

      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_NODE_SELECTED' })
      useGameStore.getState().updateBnBState({
        nodes: newNodes,
        currentNodeId: nodeId,
      })
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_COMMAND_COMPLETED' })
    })

    appBus.on('bnb-node-updated', ({ node }) => {
      logger.log('[BnBUI Adapter] bnb-node-updated', node.id)
      const state = useGameStore.getState().ui.bnbState
      const newNodes = new Map(state.nodes)
      newNodes.set(node.id, node)

      const updates: Partial<typeof state> = { nodes: newNodes }
      if (!state.currentNodeId) {
        updates.currentNodeId = node.id
      }

      useGameStore.getState().updateBnBState(updates)
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_COMMAND_COMPLETED' })
    })

    appBus.on('bnb-incumbent-updated', ({ nodeId }) => {
      logger.log('[BnBUI Adapter] bnb-incumbent-updated')
      useGameStore.getState().updateBnBState({ incumbentNodeId: nodeId })
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_COMMAND_COMPLETED' })
    })

    appBus.on('bnb-backtracked', ({ state }) => {
      logger.log('[BnBUI Adapter] bnb-backtracked')
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_NODE_SELECTED' })
      useGameStore.getState().updateBnBState({
        nodes: new Map(state.nodes),
        rootNodeId: state.rootNodeId,
        currentNodeId: state.currentNodeId,
        incumbentNodeId: state.incumbentNodeId || null,
      })
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_COMMAND_COMPLETED' })
    })

    appBus.on('bnb-reset', () => {
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_RESET_REQUESTED' })
      useGameStore.getState().resetBnB()
    })

    appBus.on('bnb-finished', ({ incumbent, stats }) => {
      logger.log('[BnBUI Adapter] bnb-finished', {
        incumbentValue: incumbent?.value,
        created: stats?.created,
        pruned: stats?.pruned,
        fathomed: stats?.fathomed,
      })
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_FINISHED' })
      useGameStore.getState().dispatchBnBFlowEvent({ type: 'BNB_COMMAND_COMPLETED' })
    })
  }

  setMaxNodes(limit: number): void {
    useGameStore.getState().updateBnBState({ maxNodes: limit })
  }
}

export const bnbUI = new BnBUI()
